<template lang="html">
  <div class="section-table column">
    <div class="header-array row">
      <div class="header-col row" v-for="(col, key) in columns" :style="{ width: col.width + 'px' }" v-bind:key="key" @click="setFilter(key)">
        {{ col.name }}
        <span class="arrow" :class="{down: isFiltered(key)}"></span>
      </div>
      <div class="deploy header-col row" style="width: 20px"></div>
    </div>
    <div class="body-array">
      <div class="body-row column" v-for="(row, key) in computedRows" v-bind:key="key">
        <div class="inner-row row start">
          <div class="body-cell" v-for="(col, colKey) in columns" :style="{ width: col.width + 'px'}" @click="deployRow(key)" v-bind:key="colKey">
            <template v-if="typeof col.cellRenderer !== 'undefined' && col.cellRenderer">
              <div v-html="col.cellRenderer({value: row.data[col.field]})"></div>
            </template>
            <template v-else-if="col.field === 'actions'">
							<div class="body-row-actions">
								<span
											class="action-item" v-for="(action, index) in col.actions"
											:key="index"
											@click="emitActionClick(row, action)"
								>
									<i
										v-if="typeof col.actionRenderer === 'undefined' && !col.actionRenderer"
										:class="action.icon"
									>
									</i>
									<span v-else v-html="col.actionRenderer(action, row)" />
								</span>
							</div>
						</template>
						<template v-else>{{ row.data[col.field] }}</template>
          </div>
          <div class="deploy row body-cell" style="width: 20px" @click="deployRow(key)" :class="{ active: rows[key].deploy }">
            <span class="icon-arrow-full-down" v-if="typeof rows[key].childrenRows !== 'undefined' && rows[key].childrenRows.length > 0"></span>
          </div>
        </div>
        <div class="row-child" :class="{ active: rows[key].deploy }">
          <div class="header-child row">
            <div class="header-col bold" v-for="(col, keyt) in rows[key].childrenColumn" :style="{ width: col.width + 'px' }" v-bind:key="keyt">
              {{ col.name }}
            </div>
          </div>
          <div class="body-child column">
            <div class="row-body-child row" v-for="(childrenRow, childrenRowKey) in rows[key].childrenRows" v-bind:key="childrenRowKey">
              <div class="cell-child" :style="{ width: childrenColumn.width + 'px' }" v-for="(childrenColumn, childrenColumnKey) in rows[key].childrenColumn" v-bind:key="childrenColumnKey">
                {{ childrenRow[childrenColumn.field] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
	props: ['columns', 'rows', 'rowsStyle'],
	data () {
		return {
			filter: {
				key: null,
				asc: true
			}
		}
	},
	methods: {
		deployRow (key) {
			for (let index in this.rows) {
				let row = this.rows[index]

				if (parseInt(index) === parseInt(key) &&
						typeof row.childrenRows !== 'undefined' &&
						row.childrenRows.length > 0) {
					row.deploy = !row.deploy
				}
			}
		},
		setFilter (key) {
			if (this.filter.key === key) {
				this.filter.asc = !this.filter.asc
			} else {
				this.filter = {
					key: key,
					asc: true
				}
			}
		},
		isFiltered (key) {
			return (key === this.filter.key) ? this.filter.asc : false
		},
		emitActionClick (row, action) {
			this.$emit('action-item-clicked', {row, action})
		}
	},
	computed: {
		computedRows () {
			let result = this.rows
			if (this.filter.key !== null) {
				result = result.sort((a, b) => {
					const value = (this.filter.asc) ? (a.data[this.filter.key] > b.data[this.filter.key]) : (a.data[this.filter.key] < b.data[this.filter.key])
					return (value) ? 1 : -1
				})
			}
			return result
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// section-table.vue?4078f0cc